import moment from 'moment/moment';
import { DateRange, DatePickerPreset } from '@round/creatorbase-ui';

export const FOLLOWERS_COLOR = 'hsl(250, 65%, 65%)';
export const LIKES_COLOR = 'hsl(160, 60%, 50%)';
export const AVG_VIDEO_PLAYS_COLOR = 'hsl(30, 80%, 55%)';

export const getLatestStatsOnEachDay = <T extends { timestamp: string }>(stats: T[]) => {
    const fromRecentToOld = [...(stats ?? [])].sort(
        (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
    const getDateString = (timestamp: string) => timestamp.split('T')[0];
    const dates = new Set();
    return fromRecentToOld?.filter((el) => {
        const dateString = getDateString(el.timestamp);
        const isDuplicate = dates.has(dateString);
        if (!isDuplicate) {
            dates.add(dateString);
        }

        return !isDuplicate;
    });
};

export const sortFromOldToRecent = <T extends { timestamp: string }>(stats: T[]) => {
    return [...(stats ?? [])].sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
};

export const DATE_PRESETS: DatePickerPreset[] = [
    { label: '7 days', value: 7 },
    { label: '30 days', value: 30 },
    { label: '90 days', value: 90 },
    { label: '6 months', value: 180 },
    { label: '1 year', value: 365 },
];

export const filterWithinDateRange = <T extends { timestamp: string }>(items: T[], dateRange?: DateRange): T[] => {
    return items.filter((item) => {
        if (!dateRange || (!dateRange.from && !dateRange.to)) {
            return true;
        }

        const itemDate = moment(item.timestamp);
        const startDate = moment(dateRange.from);
        const endDate = moment(dateRange.to);
        if (!dateRange.from) {
            return itemDate.isSameOrBefore(endDate, 'days');
        }

        if (!dateRange.to) {
            return itemDate.isSameOrAfter(startDate, 'days');
        }

        return itemDate.isSameOrAfter(startDate, 'days') && itemDate.isSameOrBefore(endDate, 'days');
    });
};
